module.exports = __webpack_public_path__ + "static/img/2.17925d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/2.jpg
// module id = i/H9
// module chunks = 1